import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Formula } from "../components/Formula";
import { MenuPreview } from "../components/MenuPreview";
import { StoryTeaser } from "../components/StoryTeaser";
import { Social } from "../components/Social";
import { FindLab } from "../components/FindLab";
import { Seo } from "../components/Seo";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Fried Chicken Engineered in New Jersey"
        description="Chicken Labb turns flavor into a formula. Engineered precision, cinematic crunch — fried chicken in New Jersey. Precision in the kitchen, art on the plate."
        path="/"
      />
      <Hero />
      <Marquee />
      <Formula />
      <MenuPreview />
      <StoryTeaser />
      <Social />
      <FindLab />
    </main>
  );
}
